import Collapsable from "../collapsable";
import Form from "../form";
import $ from "jquery";
import { trackSignUp } from "../analytics";

export class CompleteRegistration {
    private collapsable: Collapsable;
    private static readonly fullRegistrationSwitchId = 'full-registration-switch';
    private static readonly fullRegistrationAreaId = 'full-registration';


    constructor() {
        this.collapsable = new Collapsable(CompleteRegistration.fullRegistrationSwitchId, CompleteRegistration.fullRegistrationAreaId);
    }

    process(event: Event): void {
        const formElement = document.querySelector('[data-component=CompleteRegistration] form') as HTMLFormElement;

        const actionUrl = formElement.getAttribute('action');
        const form = new Form(actionUrl, formElement,
            this.replaceComponentContent,
            (html: string) => this.onModelError(html));

        form.process(event);
    }

    private onModelError(html: string): void {
        const viewcomponent = document.querySelector('[data-component=CompleteRegistration]');
        viewcomponent.innerHTML = html;

        const formToRefresh = document.querySelector('[data-component=CompleteRegistration] form');
        $.validator.unobtrusive.parse(formToRefresh);
    }

    private replaceComponentContent(html: string): void {
        trackSignUp('password');
        document.querySelector('[data-component="CompleteRegistration"]').innerHTML = html;
    }

}
